import React, { useState } from 'react';
import { StaffLeavesPage, PayslipsPage, IncentivesPage, StaffAdvancesPage } from './StaffPagesBundle';

// PayrollHubPage consolidates 4 GenericCrudPage stubs (leaves / payslips /
// incentives / advances) into one workspace with internal tabs, mirroring the
// PharmacyPage / ClinicalPage pattern. Legacy hub keys still resolve here via
// `initialTab`.
const PAYROLL_TABS = [
  { key: 'leaves',     label: 'Leaves',         Page: StaffLeavesPage },
  { key: 'payslips',   label: 'Payslips',       Page: PayslipsPage },
  { key: 'incentives', label: 'Incentives',     Page: IncentivesPage },
  { key: 'advances',   label: 'Advances/Loans', Page: StaffAdvancesPage },
];

const LEGACY_MAP = {
  'staff-leaves':   'leaves',
  'payslips':       'payslips',
  'incentives':     'incentives',
  'staff-advances': 'advances',
};

const PayrollHubPage = ({ API_BASE, initialTab = 'leaves' }) => {
  const [tab, setTab] = useState(LEGACY_MAP[initialTab] || initialTab);
  const Active = PAYROLL_TABS.find(t => t.key === tab) || PAYROLL_TABS[0];

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {PAYROLL_TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{
              padding: '9px 20px', borderRadius: 8, border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: '0.86rem',
              backgroundColor: tab === t.key ? '#0582ca' : '#e9ecef',
              color: tab === t.key ? 'white' : '#555',
            }}>
            {t.label}
          </button>
        ))}
      </div>
      <Active.Page API_BASE={API_BASE} />
    </div>
  );
};

export default PayrollHubPage;
